import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { LanguageProvider } from "@/i18n";
import { AuthProvider } from "@/context/AuthContext";
import SurveyLanding from "@/pages/SurveyLanding";
import Products from "@/pages/Products";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import ResetPassword from "@/pages/ResetPassword";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SurveyLanding />} />
          <Route path="/products" element={<Products />} />
          <Route path="/vending/:machineId" element={<SurveyLanding />} />
          <Route path="/vending/:machineId/products" element={<Products />} />
          <Route
            path="/admin/login"
            element={<AuthProvider><AdminLogin /></AuthProvider>}
          />
          <Route path="/admin/reset" element={<ResetPassword />} />
          <Route
            path="/admin"
            element={<AuthProvider><AdminDashboard /></AuthProvider>}
          />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
